import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FloppyDisk, Smiley } from "@phosphor-icons/react";
import { REPURPOSE_TONES as TONES, EMOJI_LEVELS } from "@/lib/repurposeConstants";

export function RepurposeConfig({
  tones, toggleTone, emojiLevel, setEmojiLevel,
  additionalContext, setAdditionalContext,
  aiModel, setAiModel, availableModels,
  chainMode, saveToHistory, setSaveToHistory,
}) {
  return (
    <>
      {/* Tones */}
      <div>
        <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2">Tone</label>
        <div className="flex flex-nowrap overflow-x-auto gap-1.5 pb-1 md:flex-wrap md:overflow-visible md:pb-0 no-scrollbar">
          {TONES.map((tone) => (
            <button key={tone} onClick={() => toggleTone(tone)} data-testid={`repurpose-tone-${tone.toLowerCase()}`}
              className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${
                tones.includes(tone) ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-secondary)]"
              }`}>{tone}</button>
          ))}
        </div>
      </div>

      {/* Emoji level */}
      <div>
        <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2 flex items-center gap-1.5">
          <Smiley size={14} /> Emoji Usage
        </label>
        <div className="flex gap-2">
          {EMOJI_LEVELS.map((lvl) => (
            <button key={lvl.value} onClick={() => setEmojiLevel(lvl.value)} data-testid={`emoji-${lvl.value}`}
              className={`flex-1 px-3 py-2 rounded-md text-center border transition-all ${
                emojiLevel === lvl.value ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-secondary)]"
              }`}>
              <div className="text-xs font-medium">{lvl.label}</div>
              <div className="text-[10px] opacity-60">{lvl.desc}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Additional context */}
      <textarea value={additionalContext} onChange={(e) => setAdditionalContext(e.target.value)}
        placeholder="Any specific angle, hook, or adjustment..."
        className="w-full bg-[var(--bg-base)] border border-[var(--border-strong)] rounded-md px-3 py-2 text-sm text-[var(--text-primary)] placeholder:text-[var(--text-muted)] focus:outline-none focus:ring-1 focus:ring-[#FF4400] resize-none h-16"
        data-testid="repurpose-additional-context" />

      {/* Model + Save row */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block font-['JetBrains_Mono'] text-xs uppercase tracking-[0.2em] text-[var(--text-muted)] mb-2">AI Model</label>
          <Select value={aiModel} onValueChange={setAiModel}>
            <SelectTrigger className="bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-primary)] focus:ring-1 focus:ring-[#FF4400] h-10" data-testid="repurpose-model-select">
              <SelectValue placeholder="Select model" />
            </SelectTrigger>
            <SelectContent className="bg-[var(--bg-raised)] border-[var(--border-strong)]">
              {availableModels.map((m) => (
                <SelectItem key={m} value={m} className="text-[var(--text-secondary)] focus:bg-[var(--accent-subtle)] focus:text-white">{m}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex items-end">
          {!chainMode ? (
            <button onClick={() => setSaveToHistory(!saveToHistory)} data-testid="repurpose-save-toggle"
              className={`flex items-center gap-2 px-4 py-2.5 rounded-md text-xs font-medium border transition-all w-full ${
                saveToHistory ? "bg-[var(--accent-subtle)] border-[#FF4400] text-[#FF4400]" : "bg-[var(--bg-base)] border-[var(--border-strong)] text-[var(--text-muted)]"
              }`}>
              <FloppyDisk size={14} /> {saveToHistory ? "Auto-save to history" : "Don't save"}
            </button>
          ) : (
            <div className="flex items-center gap-2 px-4 py-2.5 rounded-md text-xs font-medium border border-[var(--border-strong)] bg-[var(--bg-base)] text-[var(--text-muted)] w-full" data-testid="chain-auto-save-info">
              <FloppyDisk size={14} /> Chain always saves
            </div>
          )}
        </div>
      </div>
    </>
  );
}
